import $ from 'jquery';
import 'bootstrap';
import { standardAjaxPost } from 'stdjs/standard-ajax';

$(document).ready(function(){

    $('.carousel').carousel();

    $("#SEARCH_SUBMIT").click(function(e){
        e.preventDefault();

        var data = $("#TRACKER_FORM").serialize();

        standardAjaxPost(searchUrl, data, function (data) {
            location.href = data.url;
        });
    });

});

